"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-duplicates */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
var pagination_1 = __importDefault(require("../../pagination"));
var Table_1 = __importDefault(require("./components/Table"));
var Table = function (_a) {
    var tableData = _a.data, paginationOpts = _a.paginationOpts, dataFilterCallback = _a.dataFilterCallback;
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var _b = (0, react_1.useState)(1), pageIndex = _b[0], setPageIndex = _b[1]; // 分页组件默认显示的组件的页
    var _c = (0, react_1.useState)(0), total = _c[0], setTotal = _c[1]; // 分页组件总数
    var _d = (0, react_1.useState)([]), filterData = _d[0], setFilterData = _d[1];
    var _e = (0, react_1.useState)({}), filerOb = _e[0], setFilterOb = _e[1];
    var _f = tableData.col, col = _f === void 0 ? [] : _f, row = tableData.row;
    var pageSize = paginationOpts.pageSize;
    /*
     * 分页函数
     * @param {Array} data - 要分页的数组
     * @param {number} pageIndex - 当前页码（从1开始）
     * @param {number} pageSize - 每页条数
     * @returns {Object} 分页后的数据和分页信息
     */
    function paginate(data, pageIndex, pageSize, filerOb) {
        var _row = data
            .filter(function (item) {
            var _a = item.data, data = _a === void 0 ? [] : _a;
            if (data && data.length === 0) {
                return false;
            }
            for (var _i = 0, _b = Object.keys(filerOb); _i < _b.length; _i++) {
                var index = _b[_i];
                if (filerOb[index].length && !filerOb[index].includes(data[index].text)) {
                    return false;
                }
            }
            return true;
        })
            .sort(function (a, b) {
            var _a = a.data, data = _a === void 0 ? [] : _a;
            var _b = a.data, _data = _b === void 0 ? [] : _b;
            var index = col.findIndex(function (item) { return item.defaultSort; }) === -1
                ? data.length >= 2
                    ? 1
                    : 0
                : col.findIndex(function (item) { return item.defaultSort; });
            var _c = (data[index] || {}).text, text = _c === void 0 ? '' : _c;
            var _d = (_data[index] || {}).text, _text = _d === void 0 ? '' : _d;
            return text.localeCompare(_text);
        });
        var total = _row.length;
        dataFilterCallback(_row, col);
        // 计算起始索引
        var startIndex = (pageIndex - 1) * pageSize;
        // 计算结束索引，确保不超过数组长度
        var endIndex = Math.min(startIndex + pageSize, total);
        // 获取当前页的数据
        var pageData = _row.slice(startIndex, endIndex);
        return { pageData: pageData, total: total };
    }
    (0, react_1.useEffect)(function () {
        if (Object.keys(tableData).length !== 0) {
            var _a = paginate(tableData.row || [], pageIndex, pageSize, filerOb), pageData = _a.pageData, total_1 = _a.total;
            setFilterData(pageData);
            setTotal(total_1);
        }
    }, [pageIndex, filerOb]);
    (0, react_1.useEffect)(function () {
        if (Object.keys(tableData).length !== 0) {
            var _a = paginate(tableData.row || [], 1, pageSize, {}), pageData = _a.pageData, total_2 = _a.total;
            setFilterOb({});
            setPageIndex(1);
            setFilterData(pageData);
            setTotal(total_2);
        }
    }, [tableData]);
    return (react_1.default.createElement("div", { className: "".concat(classPrefix, "__treeTable-right-tab-table") },
        react_1.default.createElement(Table_1.default, { paginationOpts: paginationOpts, filerOb: filerOb, setFilterOb: setFilterOb, allTableData: row, col: col, row: filterData, setFilterData: filterData, setPageIndex: setPageIndex }),
        total / paginationOpts.pageSize > 1 && (react_1.default.createElement("div", { className: "".concat(classPrefix, "__treeTable-right-tab-table-pagination") },
            react_1.default.createElement(pagination_1.default, { total: total, pageIndex: (pageIndex || 1) && Number(pageIndex), pageSize: paginationOpts.pageSize || 5, onPagingChange: function (query) {
                    setPageIndex(query.pageIndex);
                }, placeholder: paginationOpts.placeholder || 'Jump', pageText: paginationOpts.pageText || 'page', goText: paginationOpts.goText || 'go' })))));
};
exports.default = Table;
//# sourceMappingURL=Table.js.map